export const WorkspaceStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const
export type WorkspaceStatusType = ObjectValues<typeof WorkspaceStatus>
